// extracted by mini-css-extract-plugin
export default {"list":"Statistics_list__QSSKj","item":"Statistics_item__5jALf"};